exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.withdraw-result .van-pull-refresh__track {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 100%;\n}\n.withdraw-result .van-pull-refresh__loading {\n  color: #fff;\n}\n.withdraw-result .van-pull-refresh__loading .van-loading {\n  color: #fff !important;\n}", ""]);

// exports
